import { colorCharts } from "data/palettes";
import { useRef } from "react";
import { Cell, Pie, PieChart, Tooltip } from "recharts";
import colorsStore from "shared/store/colorsStore";
import styles from "./../portfolioTablePie.module.scss";

const FinecoPieChart = ({ dataItem }) => {
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);
  const containerRef = useRef(null);

  const truncate = (text, maxLength) =>
    text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div
          className={styles.tooltipContainer}
          style={{
            backgroundColor: "white",
            border: `1px solid ${colorsConfig.FinecoGrayLight1}`,
            padding: "8px 10px",
            borderRadius: "4px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          }}
        >
          {payload.map((entry: any, index: number) => {
            if (entry.value === undefined) return null;
            return (
              <div key={`value-${index}`}>
                <p
                  style={{
                    color: entry.payload.fill,
                    margin: "3px 0",
                    fontSize: "12px",
                  }}
                >
                  {truncate(String(entry.payload.label), 20) +
                    ": " +
                    entry.payload.payload.weight.toFixed(2)}
                  %
                </p>
              </div>
            );
          })}
        </div>
      );
    }
    return null;
  };

  return (
    <div
      ref={containerRef}
      className={styles.pieChartContainer}
      style={{ minHeight: "100%", width: "100%" }}
    >
      <PieChart width={200} height={200}>
        <Pie
          data={dataItem.data}
          dataKey="weight"
          nameKey="label"
          cx="50%"
          cy="50%"
          innerRadius="70%"
          outerRadius="100%"
          isAnimationActive={false}
        >
          {dataItem.data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={colorsConfig[colorCharts[index % colorCharts.length]]}
            />
          ))}
        </Pie>
        {/* <Tooltip
          formatter={(value, name) => [
            `${truncate(String(name), 20)}: ${Number(value).toFixed(2)}%`,
          ]}
          contentStyle={{
            width: "100%",
            textAlign: "center",
            boxShadow: "0px 4px 8px 0px rgba(28, 34, 38, 0.06)",
            borderRadius: "8px",
            border: "1px solid #e0e0e0",
            padding: "10px",
          }}
        /> */}
        <Tooltip content={<CustomTooltip />} />
      </PieChart>
    </div>
  );
};

export default FinecoPieChart;
